import st from "@/styles/Ui.module.scss";
import CMS from "@/utils/cms.ts";
import {LocalLanguage} from "@/types_and_interfaces/types.ts";
import {useTranslation} from "react-i18next";


interface PartsInterface {
    label: string
    url?:string
}

const Bottom = () => {
    const {i18n} = useTranslation()
    // const [raw_inf, set_raw_inf] = useState<any>({})
    const raw_inf = CMS.copyright_inf
    const copyright_inf = raw_inf ? CMS.langAwareFilter(raw_inf, (i18n.language as LocalLanguage)) : {}
    const currentYear = new Date().getFullYear();

    const {link, link_text, operator, year} = copyright_inf
    
    
    const parts:Array<PartsInterface> = [
        {
            label: typeof year === "string" ? year?.replace("{{year}}", String(currentYear)) : "",
        },
        {
            label: operator,
        },
        {
            label: link_text,
            url: link
        }
    ]

    
    return (
        <div className={st.bottom}>
            {parts.map((p:PartsInterface, i) => {
                return p.url ? (
                    <a key={`p_${i}`} href={import.meta.env.VITE_WEBSITE_URL + p.url}>
                        {p.label}
                    </a>
                    ) : (
                    <span key={`p_${i}`}>
                        {p.label}
                    </span>
                )
            })}
        </div>
    )
}

export default Bottom